export const API_KEY = "AIzaSyD2ZJyD6yimorX2CS9ulbnnD4YcwHnCekw";

export default API_KEY;
